module.exports = __webpack_public_path__ + "img/bing8-logo.02c08ffb.png";